<template>
<div class="chapter">
<div class="inner_page">
<p class="fm">Raise not your children in disdain of Israel; I say unto you, take out the venom from your Scripture so that my people may live!</p>
<p class="right1-1"><span>D. D. R.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter01.vue?ef69b5de